// extracted by mini-css-extract-plugin
export default {"videoItem":"index-module__videoItem--vL9Xx","isScrollItem":"index-module__isScrollItem--MgkLL"};